export const ALLOWED_IMAGE_UPLOAD_MIME_TYPES = ["image/jpeg", "image/png"];
